function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
    
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
    
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function fireEvent(element,event){
    if (document.createEventObject){
    // dispatch for IE
    var evt = document.createEventObject();
    return element.fireEvent('on'+event,evt)
    }
    else{
    // dispatch for firefox + others
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent(event, true, true ); // event type,bubbling,cancelable
    return !element.dispatchEvent(evt);
    }
}

waitForElm('.rc-widget').then((elm) => {

  //======= For fre dropdown position
         if(elm.querySelector('.rc-selling-plans-dropdown') != null) {
              if(elm.querySelector('.subscription-radio') != null) {
               elm.querySelector('.subscription-radio').append(elm.querySelector('.rc-selling-plans-dropdown'));  
            }
         }


  //===============Position change of info
  if(elm.querySelector('.subscription-radio') != null) {
    if(document.querySelector('[data-subs-content]') != null) {
      elm.querySelector('.subscription-radio').append(document.querySelector('[data-subs-content]'));
    }
  }
  if(elm.querySelector('.onetime-radio') != null) {
    if(document.querySelector('[data-onetime-content]') != null) {
      elm.querySelector('.onetime-radio').append(document.querySelector('[data-onetime-content]'));
    }
  }
  
  
  if(document.querySelector('.rc-selling-plans-dropdown__select')){

    const selectTag = document.querySelector('.rc-selling-plans-dropdown__select');
   // selectTag.value = '1359708221';
    //fireEvent(selectTag, 'change')


    selectTag.querySelectorAll('option').forEach((option, index) => {
          let optionValue = option.innerText.toLowerCase();
          if(optionValue.includes('3 weeks')) {
             console.log('optionValue11', optionValue);
             selectTag.selectedIndex = index;
            fireEvent(selectTag, 'change');
          }
    });
                       
    
  }
  
  let subSaving = document.querySelector('.rc-radio.subscription-radio .discount-label');
 
  
  subSaving.outerHTML = '<span class="discount-label-prepend">SUBSCRIBE</span> ' + subSaving.innerHTML + '  OFF';
  
  // let arrow = document.querySelector('.rc-selling-plans-dropdown__select');      
  // arrow.outerHTML += '<svg xmlns="http://www.w3.org/2000/svg" class="rc-arrow" width="12.134" height="12.134" viewBox="0 0 12.134 12.134"><path id="Path_10_Copy" data-name="Path 10 Copy" d="M.143,0,0,8.05H8.193" transform="translate(0.33 5.799) rotate(-45)" fill="none" stroke="#00577d" stroke-miterlimit="10" stroke-width="0.9"/></svg>';


        let currentVariantNew = '';
        if(document.querySelector('[data-product-template]').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse(document.querySelector('[data-product-template]').querySelector('[data-product-json]').textContent);
          let fieldsets = Array.from(document.querySelector('[data-product-template]').querySelectorAll('fieldset'));
          let selectedValue = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
          productJson.variants.forEach((variant) => {
                if(JSON.stringify(variant.options) == JSON.stringify(selectedValue)) {
                   unitPrice = variant.price;
                  currentVariantNew = variant;
                } 
           });


            if(productJson.options.length > 0) {
             let packSizeIndex = -1;
             productJson.options.forEach((option, index) => {
                let optionName = option.toLowerCase();
                if(optionName.includes("pack size")) {
                    packSizeIndex = index;
                }
             });
              let productTags = productJson.tags.toString().toLowerCase();
              if(productTags.includes("type_") && packSizeIndex >= 0) {

                let tagName = '';
                productJson.tags.forEach((tag) => {
                   let temp = tag.toLowerCase();
                    if(temp.includes('type_')) {
                       tagName = temp.replace('type_', '');
                    }
                });
             
                let packNumber = Number(currentVariantNew.options[packSizeIndex].toLowerCase().replace('pack', ''));
                let unitPrice = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.price/packNumber / 100));
                let priceHTML = `<span>${unitPrice} per ${tagName}</span> ${(new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.price/100))}`;
                if(document.querySelector('[data-product-template]').querySelector('.subscription-radio') != null) {
                    let unitPriceSubs = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.selling_plan_allocations[0].price/packNumber / 100));
                    let priceSubsHTML = `<span>${unitPriceSubs} per ${tagName}</span> ${(new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(currentVariantNew.selling_plan_allocations[0].price/100))}`;
                    if(document.querySelector('[data-product-template]').querySelector('.subscription-radio .price-label') != null) {
                      document.querySelector('[data-product-template]').querySelector('.subscription-radio .price-label').innerHTML = priceSubsHTML;
                    }
                     if(document.querySelector('[data-product-template]').querySelector('.onetime-radio .price-label') != null) {
                      document.querySelector('[data-product-template]').querySelector('.onetime-radio .price-label').innerHTML = priceHTML;
                    }
                }
              }
           }
          
        }
 
  
  var currentVariant = document.querySelector('.current-variant');
  
  var price = document.querySelector('.rc-radio--active .price-label');
  // var price = document.querySelector('.rc-radio--active .rc-radio__price');

  // console.log(price);

  var html = price.innerHTML;

  var num = +html.replace(/[^0-9.]/g,"");

  //var priceOfItem = currentVariant.innerHTML.split("/")[1];
  
  var nameOfItem = currentVariant.innerHTML.split("/")[0];
  var priceOfItem = '';
  if(currentVariant.innerHTML.split("/")[1] != undefined) {
    priceOfItem = Number(currentVariant.innerHTML.split("/")[1].toLowerCase().replace('pack', '').replace(/\s+/g,''));
  }
  
  var nameOfItem = nameOfItem.slice(0, -2); 

   if(currentVariantNew.options.length == 1 ) {
      // priceOfItem = currentVariant.innerHTML;
      priceOfItem = Number(currentVariant.innerHTML.toLowerCase().replace('pack', '').replace(/\s+/g,''));
    }
  //new price
 
  num = currentVariantNew.selling_plan_allocations[0].price;
 
  var priceOfItem = (num / priceOfItem);

  var priceText = document.querySelector('.breakdown-price');
  var itemText = document.querySelector('.breakdown-item');

  priceText.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(priceOfItem/100));

    if( currentVariantNew.options.length >= 2 ) {
      itemText.textContent = (nameOfItem); 
    }
  

  document.querySelector(".rc-radio.subscription-radio input").addEventListener("click",function(e) {

    // setTimeout(() => {
    //   const selectTag = document.querySelector('.rc-selling-plans-dropdown__select');
    //   selectTag.value = '1359708221';
    //    console.log({selectTag})
    //   fireEvent(selectTag, 'change')
    // }, 100)

    var priceSub = document.querySelector('.sub-price');
    var priceNormal = document.querySelector('.normal-price');

    priceSub.classList.remove('hidden');
    priceNormal.classList.add('hidden');
    
    let sub = document.querySelector('.sub-container');
    let otp = document.querySelector('.otp-container');
   // otp.classList.add('hidden');
    sub.classList.remove('hidden');
    
    setTimeout(function () {



       //================New script
               
        let unitPrice = '';
       let currentVariantNew = '';
        if(document.querySelector('[data-product-template]').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse(document.querySelector('[data-product-template]').querySelector('[data-product-json]').textContent);
          let fieldsets = Array.from(document.querySelector('[data-product-template]').querySelectorAll('fieldset'));
          let selectedValue = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
            productJson.variants.forEach((variant) => {
                if(JSON.stringify(variant.options) == JSON.stringify(selectedValue)) {
                   unitPrice = variant.selling_plan_allocations[0].price;
                   currentVariantNew = variant;
                } 
           });
         }

            


      
      // let arrow = document.querySelector('.rc-selling-plans-dropdown__select');      
      // arrow.outerHTML += '<svg xmlns="http://www.w3.org/2000/svg" class="rc-arrow" width="12.134" height="12.134" viewBox="0 0 12.134 12.134"><path id="Path_10_Copy" data-name="Path 10 Copy" d="M.143,0,0,8.05H8.193" transform="translate(0.33 5.799) rotate(-45)" fill="none" stroke="#00577d" stroke-miterlimit="10" stroke-width="0.9"/></svg>';
      
      // console.log('sub running');
      
      var currentVariant = document.querySelector('.current-variant');
      
      var price = document.querySelector('.rc-radio--active .price-label');
      // var price = document.querySelector('.rc-radio--active .rc-radio__price');
    
      var html = price.innerHTML;
  
      var num = +html.replace(/[^0-9.]/g,"");
  
      //var priceOfItem = currentVariant.innerHTML.split("/")[1];
      var priceOfItem = '';
      if(currentVariant.innerHTML.split("/")[1] != undefined) {
        priceOfItem = Number(currentVariant.innerHTML.split("/")[1].toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
      var nameOfItem = currentVariant.innerHTML.split("/")[0];
  
      var nameOfItem = nameOfItem.slice(0, -2); 

      var newPriceOfItem = priceOfItem;
      
  

      if(currentVariantNew.options.length == 1 ) {
        // priceOfItem = currentVariant.innerHTML;
         priceOfItem = Number(currentVariant.innerHTML.toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }

       console.log('priceOfItem', priceOfItem, unitPrice);
     // var priceOfItem = (num / priceOfItem);
      var priceOfItem = (unitPrice / Number(priceOfItem));
  
      var priceText = document.querySelector('.breakdown-price');
      var itemText = document.querySelector('.breakdown-item');
  
      priceText.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(priceOfItem/100));

       if( currentVariantNew.options.length >= 2 ) {
      itemText.textContent = (nameOfItem);
       }

      var cartTotal = document.querySelector('.cart-message');
      var cartTotal = cartTotal.getAttribute('data-total');
      var cartTotal = (cartTotal / 100);
  
      var spendThreshold = document.querySelector('.spend-promo');
      var spendThreshold = spendThreshold.getAttribute('data-price');
      var spendThreshold = (spendThreshold / 100);
  
      var currentPrice = num;
  
      var newSpend = (spendThreshold - cartTotal - currentPrice);
  
      var spendToDisplay = (cartTotal + currentPrice);
      
      var spendWrapper = document.querySelector('.product__info-wrapper .spending-wrapper');
      var toReach = document.querySelector('.product__info-wrapper .to-reach');
      var toSpend = document.querySelector('.product__info-wrapper .to-spend');
      var reached = document.querySelector('.product__info-wrapper .reached');
  
      toSpend.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(newSpend));
  
      if(spendThreshold > spendToDisplay) {
        // console.log('spendThreshold more');
        toReach.classList.remove('hidden');
        reached.classList.add('hidden');
      } else {
        // console.log('spendThreshold less');
        toReach.classList.add('hidden');
        reached.classList.remove('hidden');
      }


               
      
      
    }, 1000);
  });
  
  document.querySelector(".rc-radio.onetime-radio input").addEventListener("click",function(e) {


    //================New script
               
        let unitPrice = '';
        let currentVariantNew = '';
        if(document.querySelector('[data-product-template]').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse(document.querySelector('[data-product-template]').querySelector('[data-product-json]').textContent);
          let fieldsets = Array.from(document.querySelector('[data-product-template]').querySelectorAll('fieldset'));
          let selectedValue = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
            productJson.variants.forEach((variant) => {
                if(JSON.stringify(variant.options) == JSON.stringify(selectedValue)) {
                   unitPrice = variant.price;
                  currentVariantNew = variant;
                } 
           });
         }

    
    var priceSub = document.querySelector('.sub-price');
    var priceNormal = document.querySelector('.normal-price');

    priceSub.classList.add('hidden');
    priceNormal.classList.remove('hidden');

    let sub = document.querySelector('.sub-container');
    let otp = document.querySelector('.otp-container');
    otp.classList.remove('hidden');
    //sub.classList.add('hidden');
    
    setTimeout(function () {
      
      // console.log('non sub running');      
      
      var currentVariant = document.querySelector('.current-variant');
      
      var price = document.querySelector('.rc-radio--active .price-label');
      // var price = document.querySelector('.rc-radio--active .rc-radio__label');
    
      var html = price.innerHTML;
  
      var num = +html.replace(/[^0-9.]/g,"");
  
     // var priceOfItem = currentVariant.innerHTML.split("/")[1];
      var priceOfItem = '';
      if(currentVariant.innerHTML.split("/")[1] != undefined) {
        priceOfItem = Number(currentVariant.innerHTML.split("/")[1].toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
      var nameOfItem = currentVariant.innerHTML.split("/")[0];
  
      var nameOfItem = nameOfItem.slice(0, -2); 


      if(currentVariantNew.options.length == 1 ) {
        // priceOfItem = currentVariant.innerHTML;
        priceOfItem = Number(currentVariant.innerHTML.toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
      
 
      var priceOfItem = (unitPrice / Number(priceOfItem));

      var newPriceOfItem = priceOfItem;
        
      var priceText = document.querySelector('.breakdown-price');
      var itemText = document.querySelector('.breakdown-item');

       
  
      priceText.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(priceOfItem/100));

       if( currentVariantNew.options.length >= 2 ) {
            itemText.textContent = (nameOfItem);  
       }

      var cartTotal = document.querySelector('.cart-message');
      var cartTotal = cartTotal.getAttribute('data-total');
      var cartTotal = (cartTotal / 100);
  
      var spendThreshold = document.querySelector('.spend-promo');
      var spendThreshold = spendThreshold.getAttribute('data-price');
      var spendThreshold = (spendThreshold / 100);
  
      var currentPrice = num;

      // console.log(currentPrice);
  
      var newSpend = (spendThreshold - cartTotal - currentPrice);
  
      var spendToDisplay = (cartTotal + currentPrice);
      
      var spendWrapper = document.querySelector('.product__info-wrapper .spending-wrapper');
      var toReach = document.querySelector('.product__info-wrapper .to-reach');
      var toSpend = document.querySelector('.product__info-wrapper .to-spend');
      var reached = document.querySelector('.product__info-wrapper .reached');
  
      toSpend.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(newSpend));
  
      if(spendThreshold > spendToDisplay) {
        // console.log('spendThreshold more');
        toReach.classList.remove('hidden');
        reached.classList.add('hidden');
      } else {
        // console.log('spendThreshold less');
        toReach.classList.add('hidden');
        reached.classList.remove('hidden');
      }

      
    }, 1000);
  });

});
